import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const App = createApi(config.APP_API_URL);

export default App;
